import styles from './template.css';
import {template} from './template';
import {AoflElement, customElement} from '@aofl/element';

/**
 * @summary AuthPanel
 * @extends {AoflElement}
 */
@customElement('auth-panel')
class AuthPanel extends AoflElement {
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'auth-panel';

  render() {
    return super.render(template, [styles]);
  }
}

export default AuthPanel;
